import api from './api';

const treeService = {
  async getTree(objectiveId) {
    try {
      const { data } = await api.get(`/budget/objectives/${objectiveId}/tree`);
      return data?.data || [];
    } catch (error) {
      console.warn('Tree endpoint not available, returning empty tree:', error.message);
      return [];
    }
  },
  async saveTree(objectiveId, nodes) {
    try {
      const { data } = await api.put(`/budget/objectives/${objectiveId}/tree`, nodes);
      return data;
    } catch (error) {
      console.warn('Tree save endpoint not available:', error.message);
      throw error;
    }
  }
};

export default treeService;





